import http from "../../../../../services/http.service";
import AgricituralMachine from "../models/agricultural-machine.entity";
import VehicleTypeOption from "../models/vehicle-type-option.entity";
import VehicleTypeValidation from "../models/vehicle-type-validation.entity";
import whitelabelService from "../../../../../services/whitelabel/whitelabel.service";

class AgriculturalMachineService {
  public getInfo(identifier: string) {
    const params = {
      chassis: identifier,
      api_token: process.env.REACT_APP_API_TOKEN
    };

    return http.post('v1/id-agro/', params);
  }

  public saveVehicleData(agriculturalMachine: AgricituralMachine) {
    return http.post('v1/inspection/agricultural-machinery', agriculturalMachine.formatPaylod());
  }

  public getVehicleTypes(): Promise<VehicleTypeOption[]> {
    const params = {
      api_token: whitelabelService.getWBDataCompany().api
    };

    return http.get('v1/agricultural-machinery/vehicle-types', { params })
      .then((result) => result.data.data);
  }

  public validateVehicleType(chassis: string): Promise<VehicleTypeValidation> {
    const params = {
      chassis,
      api_token: whitelabelService.getWBDataCompany().api
    };

    return http.post('v1/agricultural-machinery/vehicle-type/validate', params)
      .then((result) => result.data.data);
  }
}

export default new AgriculturalMachineService();
